export default __webpack_public_path__ + "static/media/gallery_04.52b060aa.jpg";